import api from '@/services/api'

export default (data) => new Promise((resolve,reject) => api()({
    url : '/webshop/user/',
    method : 'PUT',
    data
}).then(e => resolve(e)).catch(err => reject(err)) )  